var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemView',{on:{"back":function($event){return _vm.$router.go(-1)},"submit":_vm.handleSubmit},model:{value:(_vm.supply),callback:function ($$v) {_vm.supply=$$v},expression:"supply"}})}
var staticRenderFns = []

export { render, staticRenderFns }